import React from "react";

type WorkItem = {
    company: string;
    role: string;
    period: string;
    description: string;
    tech: string;
    link?: string;
};

const workData: WorkItem[] = [
    {
        company: "Aicadium.ai",
        role: "Software Engineer",
        period: "Apr 2024 — Present",
        description:
            "Building internal cloud services and SDLC tooling to speed up deployments and improve developer workflows. Designed scalable Golang & Python microservices, reducing API latency by 40%. Managing infrastructure with Kubernetes, Docker, CI/CD, and mentoring engineers.",
        tech: "Python • Kubernetes • Docker • CI/CD",
        link: "https://aicadium.ai/",
    },
    {
        company: "Gojek",
        role: "Senior Backend Developer",
        period: "2021 — 2023",
        description:
            "Built Golang & Elixir services serving ads to millions of merchants. Improved search Ads CTR from 3.5% ➜ 5.28% and grew revenue 92% by building a new retriever.",
        tech: "Elixir • Golang • PostgreSQL • Elasticsearch",
        link: "https://www.gojek.com/en-id/",
    },
    {
        company: "Hasura",
        role: "Fullstack Developer",
        period: "2019 — 2021",
        description:
            "Created Hasura Cloud UI with React & TypeScript and backend features in Golang. Led performance enhancements for OSS & enterprise console.",
        tech: "TypeScript • React • Golang",
        link: "https://hasura.io/",
    },
    {
        company: "Scripbox",
        role: "Frontend Developer",
        period: "2018 — 2019",
        description:
            "Delivered new features for investment web & mobile apps; collaborated on a design system across platforms.",
        tech: "React • React Native • CSS",
        link: "https://scripbox.com/",
    },
];

const WorkSection: React.FC = () => {
    return (
        <section id="work" className="py-16 px-6 bg-white">
            <div className="max-w-5xl mx-auto">
                <h2 className="text-3xl font-display font-bold text-gray-800 mb-10 text-center">
                    Work Experience
                </h2>
                <div className="space-y-8">
                    {workData.map((item) => (
                        <div
                            key={item.company}
                            className="p-6 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow"
                        >
                            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                                <div>
                                    <h3 className="text-xl font-semibold text-brand-primary">
                                        {item.role} — {item.company}
                                    </h3>
                                    <p className="text-sm text-gray-500">{item.period}</p>
                                </div>
                                {item.link && (
                                    <a
                                        href={item.link}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-sm text-brand-primary hover:underline"
                                    >
                                        Visit ↗
                                    </a>
                                )}
                            </div>
                            <p className="mt-4 text-gray-700">{item.description}</p>
                            <p className="mt-2 text-sm text-gray-600 italic">{item.tech}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WorkSection; 